// new color palette, use these going forward
// commenting out until next phase of colors
import * as colors from './baseColors';
import { ThemeColors } from 'theme/colors/colors';

const colorPrimary = colors.royalBase;
const colorSecondary = colors.slateLight;
const colorDanger = colors.watermelonBase;
const colorSuccess = colors.appleBase;
const colorWarning = colors.blazeBase;
const colorInternal = colors.sunglowBase;

export const textWhite = colors.white;
export const textLighter = colors.slateLighter;
export const textLight = colors.slateLight;
export const textBase = colors.slateBase;
export const textDark = colors.slateDark;
export const textPrimary = colors.royalBase;
export const textSuccess = colors.appleDarker;
export const textWarning = colors.blazeBase;
export const textDanger = colors.watermelonBase;
export const textInternal = colors.sunglowDarker;

export const borderWhite = colors.white;
export const borderLightest = colors.grayLight;
export const borderLighter = colors.grayBase;
export const borderLight = colors.grayDark;
export const borderBase = colors.slateLighter;
export const borderDark = colors.slateLight;
export const borderDarker = colors.slateBase;
export const borderDarkest = colors.slateDark;
export const borderPrimary = colors.royalBase;
export const borderSuccess = colors.appleDark;
export const borderWarning = colors.blazeBase;
export const borderDanger = colors.watermelonBase;
export const borderInternal = colors.sunglowBase;

export const backgroundWhite = colors.white;
export const backgroundLightest = colors.grayLight;
export const backgroundLighter = colors.grayBase;
export const backgroundLight = colors.grayDark;
export const backgroundBase = colors.slateLighter;
export const backgroundDark = colors.slateLight;
export const backgroundDarker = colors.slateBase;
export const backgroundDarkest = colors.slateDark;
export const backgroundPrimary = colors.royalBase;
export const backgroundPrimaryLight = colors.royalLight;
export const backgroundPrimaryLighter = colors.royalLighter;
export const backgroundSuccess = colors.appleDark;
export const backgroundWarning = colors.blazeBase;
export const backgroundDanger = colors.watermelonBase;
export const backgroundDangerLighter = colors.watermelonLighter;
export const backgroundInternal = colors.sunglowBase;

export const iconWhite = colors.white;
export const iconLighter = colors.slateLighter;
export const iconLight = colors.slateLight;
export const iconBase = colors.slateBase;
export const iconDark = colors.slateDark;
export const iconPrimary = colors.royalBase;
export const iconSuccess = colors.appleBase;
export const iconDanger = colors.watermelonBase;
export const iconWarning = colors.blazeBase;
export const iconInternal = colors.sunglowBase;
export const iconGuest = colors.blazeBase;
export const iconVisit = colors.lilacBase;

export const disabled = colors.grayDarker;
export const disabledBackground = colors.grayBase;

// one offs to change after all colors are done above

const lightColors: ThemeColors = {
  black: colors.black,
  white: colors.white,
  primary: colorPrimary,
  secondary: colorSecondary,
  danger: colorDanger,
  success: colorSuccess,
  warning: colorWarning,
  internal: colorInternal,

  backgroundColorBody: colors.white,
  backgroundColorPaper: colors.white,
  //below are the correct things to use
  textWhite,
  textLighter,
  textLight,
  textBase,
  textDark,
  textPrimary,
  textSuccess,
  textWarning,
  textDanger,
  textInternal,

  borderWhite,
  borderLightest,
  borderLighter,
  borderLight,
  borderBase,
  borderDark,
  borderDarker,
  borderDarkest,
  borderPrimary,
  borderSuccess,
  borderWarning,
  borderDanger,
  borderInternal,

  backgroundWhite,
  backgroundLightest,
  backgroundLighter,
  backgroundLight,
  backgroundBase,
  backgroundDark,
  backgroundDarker,
  backgroundDarkest,
  backgroundPrimary,
  backgroundPrimaryLight,
  backgroundPrimaryLighter,
  backgroundSuccess,
  backgroundWarning,
  backgroundDanger,
  backgroundDangerLighter,
  backgroundInternal,

  iconWhite,
  iconLighter,
  iconLight,
  iconBase,
  iconDark,
  iconPrimary,
  iconSuccess,
  iconDanger,
  iconWarning,
  iconInternal,
  iconGuest,
  iconVisit,

  disabled,
  disabledBackground,
};

export default lightColors;
